export function formattedDuration(currDur) {
    let date = new Date(currDur);
    date.setSeconds(currDur.toFixed(0));
    let timeString = date.toISOString().substring(15, 19)
    return timeString;
}